import {IcoChartLeaderboard, IcoFolderOutline, IcoSearchEarth} from "@marqvision/mds/assets";
import { RouteNameEnum } from '~/types/common';

export const RouteParams = [
  {
    to: RouteNameEnum.Performance,
    text: 'Performance',
    icon: IcoChartLeaderboard,
  },
  {
    to: RouteNameEnum.AssetPortfolio,
    text: 'Asset Portfolio',
    icon: IcoFolderOutline,
  },
  {
    to: RouteNameEnum.Enforcement,
    text: 'Enforcement',
    icon: IcoSearchEarth,
  },
];